export default "__VITE_ASSET__Dd7D69Qn__"